import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClientStrategyTagDetails } from "../../CommonAPI/User";
import Content from "../../../ExtraComponent/Content";
import NoDataFound from "../../../ExtraComponent/NoDataFound";
import Loader from "../../../ExtraComponent/Loader";

const StrategyTag = () => {
  const navigate = useNavigate();
  const [strategyTags, setStrategyTags] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedTag, setSelectedTag] = useState(null);
  const [loading, setLoading] = useState(true);
  const username = localStorage.getItem("name");

  const fetchStarategyTag = async () => {
    setLoading(true);
    const res = await ClientStrategyTagDetails(username);
    if (res && res.data) {
      setStrategyTags(res.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStarategyTag();
  }, []);

  return (
    <Content
      Page_title={"📄 All Strategy"}
      button_status={false}
      backbutton_status={true}
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item active " aria-current="page">
           Strategy Tag
          </li>
        </ol>
      </nav>

      {loading ? (
        <Loader />
      ) : (
  <div className="strategy-container row g-4">
  {strategyTags.length === 0 ? (
    <NoDataFound />
  ) : (
    strategyTags.map((tag, index) => (
      <div className="col-md-6 col-lg-4" key={index}>
        <div className="card strategy-card-modern shadow-sm border-0 h-100">
          
          {/* Image Section */}
          <div className="strategy-card-img d-flex justify-content-center align-items-center">
            <img
              src={
                tag.Image?.startsWith("data:image")
                  ? tag.Image
                  : `data:image/jpeg;base64,${tag.Image}`
              }
              alt={tag.Strategytag}
              className="img-fluid"
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/200x150?text=No+Image";
              }}
            />
          </div>

          {/* Content Section */}
          <div className="card-body strategy-card-content d-flex flex-column">
            <h5 className="fw-bold text-dark mb-2">{tag.Strategytag}</h5>
            
            <div className="mb-2">
              <span className="badge bg-primary me-2">
                <i className="fa-solid fa-chart-line me-1"></i>
                {tag.Indicatorname}
              </span>
            </div>
            
            <div className="description-scrollable mt-1">{tag.Description}</div>

            {/* Optional Action Buttons */}
            {/* <div className="mt-auto d-flex gap-2">
              <button className="btn btn-sm btn-outline-primary">View</button>
              <button className="btn btn-sm btn-outline-success">Apply</button>
            </div> */}
          </div>

        </div>
      </div>
    ))
  )}
</div>


      )}
    </Content>
  );
};

export default StrategyTag;
